module.exports = __webpack_public_path__ + "static/media/whale.9c3e70b4.gif";